<template>
    <div>

        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-if="editLivro && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitLivro" v-if="!editLivro || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editLivro || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Capa" prop="capa" key="capa" class="u-text-center">
                            <input-image v-model="capaFile" :maxBytes="2097152" @erro="onCapaErro" @delete="onCapaDelete"></input-image>
                            <img v-if="!capaFile && capaUrl" :src="capaUrl" class="img-avatar" style="max-width:180px; margin: 8px auto; display:block;">
                            <small class="u-text-muted">PNG ou JPEG, até 2MB.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="18" :md="18">
                                <el-form-item label="Título *" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                                    <el-input v-model="dados.titulo" maxlength="191" v-on:blur="formatData('titulo')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Ano" prop="ano_publicacao" key="ano_publicacao">
                                    <el-input v-model="dados.ano_publicacao" maxlength="4"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Autor *" prop="autor" :rules="[$requiredBlur]" key="autor">
                                    <el-input v-model="dados.autor" maxlength="191" v-on:blur="formatData('autor')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Editora" prop="editora" key="editora">
                                    <el-input v-model="dados.editora" maxlength="191" v-on:blur="formatData('editora')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="ISBN" prop="isbn" key="isbn">
                            <el-input v-model="dados.isbn" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Edição" prop="edicao" key="edicao">
                            <el-input v-model="dados.edicao" maxlength="191" v-on:blur="formatData('edicao')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Categoria / assunto" prop="categoria" key="categoria">
                            <el-input v-model="dados.categoria" maxlength="191" v-on:blur="formatData('categoria')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Tipo do livro" prop="tipo" key="tipo">
                            <el-select v-model="dados.tipo" placeholder="Selecione" clearable style="width:100%">
                                <el-option label="DIDÁTICO" value="didatico"></el-option>
                                <el-option label="PARADIDÁTICO" value="paradidatico"></el-option>
                                <el-option label="REFERÊNCIA" value="referencia"></el-option>
                                <el-option label="LITERATURA" value="literatura"></el-option>
                                <el-option label="PERIÓDICO" value="periodico"></el-option>
                                <el-option label="OUTRO" value="outro"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Classificação Dewey (CDD)" prop="cdd" key="cdd">
                            <el-input v-model="dados.cdd" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Número de tombo" prop="numero_tombo" key="numero_tombo">
                            <el-input v-model="dados.numero_tombo" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Quantidade de exemplares" prop="quantidade_exemplares" key="quantidade_exemplares">
                            <el-input v-model="dados.quantidade_exemplares" maxlength="6"></el-input>
                            <small v-if="editLivro" class="u-text-muted">Ao editar, aumentar a quantidade cria novos exemplares automaticamente.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Localização (estante/prateleira)" prop="localizacao" key="localizacao">
                            <el-input v-model="dados.localizacao" maxlength="191" v-on:blur="formatData('localizacao')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Idioma" prop="idioma" key="idioma">
                            <el-input v-model="dados.idioma" maxlength="191" v-on:blur="formatData('idioma')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Número de páginas" prop="numero_paginas" key="numero_paginas">
                            <el-input v-model="dados.numero_paginas" maxlength="6"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Sinopse / descrição" prop="sinopse" key="sinopse">
                            <el-input type="textarea" :rows="4" v-model="dados.sinopse" maxlength="2000" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-livro" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>

<script>
import InputImage from '@/shared/input-image/input-image.vue';

export default {
    props: ['paramId'],
    components: { 'input-image': InputImage },
    data: () => ({
        editLivro: false,
        capaFile: '',
        capaUrl: '',
        filtroInstituicao: { id: '', nome: '' },
        dados: {
            id: '',
            instituicao_id: '',
            titulo: '',
            autor: '',
            editora: '',
            ano_publicacao: '',
            isbn: '',
            edicao: '',
            categoria: '',
            tipo: '',
            cdd: '',
            numero_tombo: '',
            quantidade_exemplares: 0,
            localizacao: '',
            idioma: '',
            numero_paginas: '',
            sinopse: '',
            capa_path: ''
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted(){
        this.restaurarInstituicaoDoQuery();
        if(this.$store.state.config.instituicao){
            this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
    },
    methods:{
        restaurarInstituicaoDoQuery(){
            const qId = this.$route.query.instituicao_id;
            if(!qId) return;
            const atual = this.$store.state.config.instituicao;
            if(atual && atual.id && String(atual.id) === String(qId)) return;
            const lista = this.$store.state.instituicoes || [];
            const fromList = Array.isArray(lista)
                ? lista.find(x => x && String(x.id) === String(qId))
                : (lista[qId] || null);
            const inst = fromList || { id: qId, nome: '' };
            this.$store.commit('setInstituicao', inst);
        },
        getLivroById(id){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
                this.dados = JSON.parse(JSON.stringify(response.data));
                if(this.dados.capa_path){
                    this.capaUrl = `${this.$store.state.config.baseUrlApi}/storage/` + this.dados.capa_path;
                }
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        onSubmitLivro(){
            document.getElementById("btn-livro").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
                window.eventBus.$emit('loading', true);

                this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;

                const trataErro = (response) => {
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível salvar o livro.');
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return true;
                    }
                    return false;
                };

                if(this.editLivro){
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                        if(trataErro(response)) return;
                        this.uploadCapaIfNeeded(this.dados.id).then(() => {
                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitLivro');
                        });
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }else{
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/store`, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                        if(trataErro(response)) return;
                        const novoId = response.data && response.data.id ? response.data.id : null;
                        this.uploadCapaIfNeeded(novoId).then(() => {
                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitLivro');
                        });
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }
            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        uploadCapaIfNeeded(livroId){
            if(!this.capaFile || !livroId){
                return Promise.resolve();
            }
            const fd = new FormData();
            fd.append('capa', this.capaFile);
            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/uploadCapa/` + livroId,
                fd,
                this.$store.getters.getHeaderFileAuth
            );
        },
        onCapaErro(msg){
            if(msg){
                window.eventBus.$emit('alert', {msg, type: 'warning'});
            }
        },
        onCapaDelete(){
            this.capaFile = '';
            this.capaUrl = '';
        },
        formatData(field){
            if(!this.dados[field]) return false;
            this.dados[field] = this.dados[field].toUpperCase();
            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if(value){
                    this.getLivroById(value);
                    this.editLivro = true;
                }
            }
        }
    }
}
</script>
